import { css } from "@emotion/react";
import styled from "@emotion/styled";
import { fontRobotoCondensed } from "@product/scmp-sdk";

import { ZIndexLayer } from "~/lib/styles";

import IconQuickLink from "./icon/icon-quick-link.svg";

export const Container = styled.div``;

export const Button = styled.button`
  display: flex;
  justify-content: space-between;
  align-items: center;

  inline-size: 194px;
  padding-block: 10.5px;
  padding-inline: 20.5px;

  color: #999999;
  font-size: 16px;
  font-family: ${fontRobotoCondensed};
  line-height: 19px;
  letter-spacing: 0;

  border: 1px solid #f2f2f2;
  border-radius: 4px;

  background-color: #ffffff;

  cursor: pointer;
`;

export const NativeSelectWrapper = styled.div`
  position: relative;
`;

export const Select = styled.select`
  position: absolute;
  inset-block-start: 0;
  inset-inline-start: 0;

  inline-size: 100%;
  block-size: 100%;

  opacity: 0;
`;

type Props = {
  $hidden: boolean;
};

export const Listbox = styled.ul<Props>`
  position: absolute;
  z-index: ${ZIndexLayer.DropdownSelect};

  inline-size: 194px;

  border-radius: 4px;

  background-color: #ffffff;

  box-shadow: 0 0 2px 0 rgba(0, 0, 0, 0.14), 0 2px 2px 0 rgba(0, 0, 0, 0.12),
    0 1px 3px 0 rgba(0, 0, 0, 0.2);

  cursor: pointer;

  ${props =>
    props.$hidden &&
    css`
      visibility: hidden;

      opacity: 0;

      transition: opacity 0.15s, visibility 0.15s;
    `}
`;

export const StyledIconQuickLink = styled(IconQuickLink)`
  fill: #999999;
`;
